module.exports = __webpack_public_path__ + "static/media/shortTextemail.6738acb7.svg";